// === HELPERS POUR FIX MENU MOBILE (STREAMLINE + SCROLL INFINI) ===
function freezeTransformedParents() {
  const nodes = document.querySelectorAll('.transition-body, .page-container, #PageContainer');
  nodes.forEach(n => {
    if (!n) return;
    if (!n.dataset._origTransform) {
      n.dataset._origTransform = n.style.transform || '';
      n.dataset._origWillChange = n.style.willChange || '';
    }
    n.style.transform = 'none';
    n.style.willChange = 'auto';
  });
}

function restoreTransformedParents() {
  const nodes = document.querySelectorAll('.transition-body, .page-container, #PageContainer');
  nodes.forEach(n => {
    if (!n) return;
    if (typeof n.dataset._origTransform !== 'undefined') {
      n.style.transform = n.dataset._origTransform;
      n.style.willChange = n.dataset._origWillChange;
      delete n.dataset._origTransform;
      delete n.dataset._origWillChange;
    }
  });
}



// === CLASSE INFINITE SCROLL — MOBILE ===
class InfiniteScrollMobile {
  constructor() {

    // Mobile uniquement
    if (window.innerWidth > 768) return;

    // Redirection des pages vers collections
    if (window.location.pathname.startsWith('/pages/')) {
      const collectionLink = document.querySelector('.text--center a.btn[href*="/collections/"]');
      if (collectionLink) {
        window.location.href = collectionLink.href;
        return;
      }
    }

    // Uniquement collections
    if (!window.location.pathname.includes('/collections/')) return;

    this.container = document.querySelector('[data-collection-container], [data-product-container], .grid--uniform');
    this.pagination = document.querySelector('.pagination');

    if (!this.container || !this.pagination) return;

    this.nextLink = this.pagination.querySelector('a[rel="next"], .next a');
    if (!this.nextLink) return;

    this.nextUrl = this.nextLink.href;
    this.loading = false;

    this.init();
  }

  init() {
    this.pagination.style.display = 'none';

    // Loader
    this.loader = document.createElement('div');
    this.loader.style.textAlign = 'center';
    this.loader.style.padding = '20px';
    this.loader.innerHTML = `
      <div style="border:3px solid #f3f3f3;border-top:3px solid #000;border-radius:50%;
                  width:36px;height:36px;animation:spin 1s linear infinite;margin:0 auto"></div>
      <p style="color:#666;margin-top:10px;">Chargement des produits...</p>
    `;
    this.container.parentElement.appendChild(this.loader);

    // Loader animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {0% {transform: rotate(0deg);}100% {transform: rotate(360deg);}}
    `;
    document.head.appendChild(style);

    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    if (this.loading || !this.nextUrl) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const triggerPoint = document.documentElement.scrollHeight - window.innerHeight * 1.5;

    if (scrollPosition >= triggerPoint) {
      this.loadMore();
    }
  }

  async loadMore() {
    if (!this.nextUrl || this.loading) return;

    this.loading = true;
    this.loader.style.display = 'block';

    try {
      const response = await fetch(this.nextUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newContainer = doc.querySelector('[data-collection-container], [data-product-container], .grid--uniform');
      const newProducts = newContainer ? newContainer.children : [];

      Array.from(newProducts).forEach(product => {
        this.container.appendChild(product.cloneNode(true));
      });

      // Lazyload
      const lazyImages = this.container.querySelectorAll('img[data-src]');
      lazyImages.forEach(img => {
        if (!img.src && img.dataset.src) img.src = img.dataset.src;
      });

      // Recharge SAFE (pas theme.init)
      document.dispatchEvent(new CustomEvent('lazyloaded'));
      document.dispatchEvent(new CustomEvent('shopify:section:load'));

      // Nouvelle pagination
      const newPagination = doc.querySelector('.pagination');
      const newNextLink = newPagination ? newPagination.querySelector('a[rel="next"], .next a') : null;

      this.nextUrl = newNextLink ? newNextLink.href : null;

      if (!this.nextUrl) {
        this.loader.innerHTML = `<p style="color:#666;padding:20px;">Vous avez vu tous les produits ✓</p>`;
      }

    } catch (e) {
      console.error('Erreur infinite scroll mobile:', e);
    } finally {
      this.loading = false;
      this.loader.style.display = 'none';
    }
  }
}



// === CLASSE INFINITE SCROLL — DESKTOP (CORRIGÉE) ===
class InfiniteScrollDesktop {
  constructor() {

    // Desktop uniquement
    if (window.innerWidth <= 1024) return;

    if (!window.location.pathname.includes('/collections/')) return;

    this.container = document.querySelector('[data-collection-container], [data-product-container], .grid--uniform');
    this.pagination = document.querySelector('.pagination');

    if (!this.container || !this.pagination) return;

    this.nextLink = this.pagination.querySelector('a[rel="next"], .next a');
    if (!this.nextLink) return;

    this.nextUrl = this.nextLink.href;
    this.loading = false;

    this.init();
  }

  init() {
    this.pagination.style.display = 'none';
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    if (!this.nextUrl || this.loading) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const triggerPoint = document.documentElement.scrollHeight - window.innerHeight * 1.3;

    if (scrollPosition >= triggerPoint) this.loadMore();
  }

  async loadMore() {
    if (!this.nextUrl || this.loading) return;

    this.loading = true;

    try {
      const response = await fetch(this.nextUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newContainer = doc.querySelector('[data-collection-container], [data-product-container], .grid--uniform');
      if (!newContainer) return;

      Array.from(newContainer.children).forEach(item => {
        this.container.appendChild(item.cloneNode(true));
      });

      // Recharge SAFE (surtout pas theme.init)
      document.dispatchEvent(new CustomEvent('lazyloaded'));
      document.dispatchEvent(new CustomEvent('shopify:section:load'));

      const newPagination = doc.querySelector('.pagination');
      const newNextLink = newPagination ? newPagination.querySelector('a[rel="next"], .next a') : null;

      this.nextUrl = newNextLink ? newNextLink.href : null;

    } catch (err) {
      console.error("Erreur infinite scroll desktop:", err);
    } finally {
      this.loading = false;
    }
  }
}



// === INITIALISATION ===
document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScrollMobile();
  new InfiniteScrollDesktop();
});
